export default {
  namespace: 'officialAccount',
  state: {
    loading: true,
    userInfo: {},
    detailList: [],
    editData: {
      type: 1,
      money: ''
    },
    companyInfo: {},
    invoiceInfo: {},
    invoiceImageData: {},
    companyList: [],
    companyNameList: []
  },
  mutations: {
    changeLoading (state, loading) {
      state.loading = loading
    },
    changeDetailList (state, detailList) {
      state.detailList = detailList
    },
    changeEditDataType (state, type) {
      state.editData.type = type
    },
    changeEditDataMoney (state, money) {
      state.editData.money = money
    },
    changeCompanyInfo (state, companyInfo) {
      state.companyInfo = companyInfo
    },
    changeInvoiceInfo (state, invoiceInfo) {
      state.invoiceInfo = invoiceInfo
    },
    changeImage (state, invoiceImageData) {
      state.invoiceImageData = invoiceImageData
    },
    changeUserInfo (state, userInfo) {
      state.userInfo = userInfo
    },
    changeCompanyList (state, companyList) {
      state.companyList = companyList
    },
    changeCompanyNameList (state, companyNameList) {
      state.companyNameList = companyNameList
    }
  },
  actions: {}
}
